import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "..";
import { ChatSelectionAction, ChatSortField, ChatSortOrder, ChatVisibility } from "@/types/types";
import { State } from "../state";
import { LocalStorage } from "@/types/enums";

export const chatSelectionSlice = createSlice({
    name: "chatSelection",
    initialState: {
        id: localStorage.getItem(LocalStorage.LAST_CHAT_ID) ?? "",
        action: null,
        searchTerm: "",
        visibility: "all",
        sortField: "date",
        sortOrder: "desc",
    } as State.ChatSelection,
    reducers: {
        setSelectChat: (state, action: PayloadAction<string | null>) => {
            const selectedChatId = action.payload;

            state.id = selectedChatId;

            !!selectedChatId && localStorage.setItem(LocalStorage.LAST_CHAT_ID, selectedChatId);
        },
        setChatSelectionAction: (state, action: PayloadAction<ChatSelectionAction>) => {
            state.action = action.payload;
        },
        setSearchTerm: (state, action: PayloadAction<string>) => {
            state.searchTerm = action.payload;
        },
        setVisibilityFilter: (state, action: PayloadAction<ChatVisibility>) => {
            state.visibility = action.payload;
        },
        setSortField: (state, action: PayloadAction<ChatSortField>) => {
            state.sortField = action.payload;
        },
        setSortOrder: (state, action: PayloadAction<ChatSortOrder>) => {
            state.sortOrder = action.payload;
        },
    },
});

export const { setChatSelectionAction, setSearchTerm, setVisibilityFilter, setSortField, setSortOrder, setSelectChat } = chatSelectionSlice.actions;

export const useChatSelectionSlice = () => useSelector((state: RootState) => state.chatSelection);

export default chatSelectionSlice.reducer;
